import { jsx as _jsx } from "react/jsx-runtime";
import { ModalContainer } from "./ModalContainer";
import { PaymentPlanSection } from "../section/custom";
const PaymentPlanModal = (props) => (_jsx(ModalContainer, { ...props, children: _jsx(PaymentPlanSection, { formTemplateSectionId: "", fields: [], expanded: true }) }));
const modals = {
    PaymentPlanModal
};
export { modals };
//# sourceMappingURL=modals.js.map